module.exports = __webpack_public_path__ + "img/porsche.5ab579a4.webp";